import api from 'api'
import { CACHE_TAG_CONFIGURED_SERVICE_DETAILS } from 'api/cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    getServiceDetails: build.query({
      query: id => ({
        url: '/api/configured-service/detail',
        method: 'POST',
        body: { configuredServiceId: id },
      }),
      providesTags: (result, error, id) => [CACHE_TAG_CONFIGURED_SERVICE_DETAILS, { type: CACHE_TAG_CONFIGURED_SERVICE_DETAILS, id }],
    }),
  }),
})

export const { useLazyGetServiceDetailsQuery, useGetServiceDetailsQuery } = extendedApi
